module.exports = __webpack_public_path__ + "assets/13147c052c22e707f5850bfc0c425b9d.mp3";